import { API_URL, BASE_URL } from "../utils/AppApiUrl";
import { postWithCSVResponse, postFile, post } from "../utils/httpClient-methods";
import tokenHttpClient from "../utils/httpClient";

export const DownloadUsersTemplateService = async () => {
  try {
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadUsersTemplate}`
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadModelsTemplateService = async () => {
  try {
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadModelsTemplate}`
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadSparesTemplateService = async () => {
  try {
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadSparesTemplate}`
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadSparesActionTemplateService = async () => {
  try {
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadSparesActionTemplate}`
    );
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  }
  catch (err) {
    throw err;
  }
};

export const DownloadSparesStatusTemplateService = async () => {
  try {
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadSparesStatusTemplate}`
    );
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  }
  catch (err) {
    throw err;
  }
};


export const uploadBulkUsersService = async (formData) => {
  try {
    const uploadUserResponse = await postFile(
      tokenHttpClient,
      `${BASE_URL}${API_URL.uploadBulkUsers}`,
      formData
    );

    if (uploadUserResponse.status === 200) {
      return uploadUserResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const triggerPhotoService = async (body) => {
  try {
    const uploadUserResponse = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.triggerPhotoUpload}`,
      body
    );
    if (uploadUserResponse.status === 200) {
      return uploadUserResponse;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const uploadBulkModelsService = async (formData) => {
  try {
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${API_URL.uploadBulkModels}`,
      formData
    );

    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const uploadBulkSparesService = async (file, param) => {
  try {
    const formData = new FormData();
    if (file) {
      var postData = JSON.stringify(param);
      formData.append("file", file);
      formData.append("bulkSpareUploadRequest", postData);
    }
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${API_URL.uploadBulkSpares}`,
      formData
    );

    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const uploadBulkSpareActionService = async (formData) => {
  try {
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${API_URL.uploadBulkSpareAction}`,
      formData
    );

    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
}

export const uploadBulkSpareStatusService = async (formData) => {
  try {
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${API_URL.uploadBulkSpareStatus}`,
      formData
    );

    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
}


export const DownloadErrorLogsService = async (param) => {
  try {
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadErorLogs}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const DownloadPhotoErrorLogsService = async (param) => {
  try {
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadPhotoErorLogs}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadErrorSpareMasterLogsService = async (param) => {
  try {
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadSpareMasterErrorLogs}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
}

